import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, firstValueFrom, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { SystemRole } from '../models/roles';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private apiUrl = environment.apiUrl;
  public roles: BehaviorSubject<SystemRole[]> = new BehaviorSubject<SystemRole[]>([]);

  constructor(private http: HttpClient, private authService: AuthService) { }

  async initRoles(): Promise<void> {
    // If not authorized, do nothing here
    if (!this.authService.authorized.value) return;

    try {
      let roles = await firstValueFrom(this.http.get<SystemRole[]>(`${this.apiUrl}/auth/get-roles`));
      this.roles.next(roles);
    } catch {
      this.roles.next([]);
    }
  }

  resetRoles(): void{
    this.roles.next([]);
  }

  async fetchRoles(): Promise<SystemRole[]> {
    const url = `${this.apiUrl}/auth/get-roles`;
    try {
      const roles = await firstValueFrom(this.http.get<SystemRole[]>(url));
      this.roles.next(roles);
      return roles;
    } 
    catch {
      this.roles.next([]);
      return [];
    }
  }

  getRoles(): SystemRole[]{
    return this.roles.value;
  }
}